import { jsx as _jsx } from "react/jsx-runtime";
import diamondPurple from '../../../assets/gems/diamond_purple.svg?inline';
export function DiamondPurple({ ...props }) {
    return _jsx("img", { ...props, src: diamondPurple, alt: 'DiamondPurpleImage' });
}
